module.exports = __webpack_public_path__ + "static/media/e-commerce.47eb70c0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Home/img/e-commerce.svg
// module id = 236
// module chunks = 8